import BossModel from "@/models/BossModel";
import Discount from "@/models/Product/Discount/Discount";

export default class Group extends BossModel {

    static apiUrl = 'product/discount/group';

    static entity = 'productDiscountGroups';

    static fields() {
        return {
            id: this.number(null).nullable(),
            name: this.attr(null),
            product_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            discounts: this.hasMany(Discount, 'product_discount_group_id'),
        }
    }
}
